/**
 * Route names for the Dashboard app.
 */
var DashboardRouteName;
(function (DashboardRouteName) {
    DashboardRouteName["PROCEDURE_PAGE"] = "ProcedurePage";
    DashboardRouteName["NURSE_DISPATCH"] = "NurseDispatch";
    DashboardRouteName["ITINERARY"] = "Itinerary";
    DashboardRouteName["SHIFTS"] = "Shifts";
    DashboardRouteName["SHIFT_DETAILS"] = "ShiftDetails";
})(DashboardRouteName || (DashboardRouteName = {}));

export { DashboardRouteName };
